import type { DataLayerEvent } from '@/utilities/dataLayer/models';

const PURCHASE_DEDUP_PREFIX = 'dl_purchase_dedup:';

const isBrowser = () => typeof window !== 'undefined';

const getDedupKey = (event: DataLayerEvent): string | null => {
    if (event.event !== 'purchase' && event.event !== 'purchase_failed') {
        return null;
    }

    return `${PURCHASE_DEDUP_PREFIX}${event.event}:${event.ecommerce.transaction_id}`;
};

const hasBeenTracked = (dedupKey: string): boolean => {
    try {
        return sessionStorage.getItem(dedupKey) === '1';
    } catch {
        return false;
    }
};

const markAsTracked = (dedupKey: string): void => {
    try {
        sessionStorage.setItem(dedupKey, '1');
    } catch {
        return;
    }
};

export const pushDataLayer = (payload: DataLayerEvent): void => {
    if (!isBrowser()) {
        return;
    }

    const dedupKey = getDedupKey(payload);
    if (dedupKey && hasBeenTracked(dedupKey)) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload as Record<string, unknown>);

    if (dedupKey) {
        markAsTracked(dedupKey);
    }
};
